import { AxiosError } from 'axios';
import { handleLogout } from '../utils';
import { isMiddlewareUsed } from './utils';

export const handleUnauthorizedMiddleware = async (error: AxiosError) => {
  const shouldHandle = isMiddlewareUsed('handle-unauthorized', error.config);

  if (401 === error.response?.status && shouldHandle) {
    await handleLogout();

    return Promise.reject(error);
  } else return Promise.reject(error);
};
